// extracted by mini-css-extract-plugin
export default {"popUpContainer":"popup_popUpContainer__kAT9N","btn":"popup_btn__ruUte"};